// Luxury Appraisals & Authentication — site content data

export const FEATURED_BRANDS = [
  "Hermès",
  "Chanel",
  "Louis Vuitton",
  "Rolex",
  "Cartier",
  "Patek Philippe",
  "Audemars Piguet",
  "Van Cleef & Arpels",
  "Goyard",
  "Christian Dior",
  "Bottega Veneta",
  "Tiffany & Co.",
  "Saint Laurent",
  "Gucci",
  "Prada",
  "The Row",
];

export const ALL_BRANDS = [
  "3.1 Phillip Lim", "Agnès B.", "Akris", "Alaïa", "Alexander McQueen", "Alexander Wang",
  "Altuzarra", "Amiri", "Ann Demeulemeester", "Anna Sui", "Anya Hindmarch", "Aquazzura",
  "Audemars Piguet", "Balenciaga", "Bally", "Balmain", "Baume & Mercier", "Bell & Ross",
  "Belstaff", "Berluti", "Blancpain", "Blumarine", "Bottega Veneta", "Breitling", "Brioni",
  "Brunello Cucinelli", "Bulgari", "Burberry", "Calvin Klein", "Canada Goose",
  "Carolina Herrera", "Cartier", "Céline", "Chanel", "Charlotte Olympia", "Chloé", "Chopard",
  "Christian Dior", "Christian Lacroix", "Christian Louboutin", "Coach", "Comme des Garçons",
  "Courrèges", "David Yurman", "Delvaux", "Dennis Basso", "Dolce & Gabbana", "Donna Karan",
  "Dooney & Bourke", "Dries Van Noten", "Dunhill", "Emanuel Ungaro", "Emilio Pucci",
  "Ermenegildo Zegna", "Escada", "Fauré Le Page", "Fear of God", "Fendi", "Furla",
  "Gianfranco Ferré", "Giorgio Armani", "Giuseppe Zanotti", "Givenchy", "Goyard", "Gucci",
  "Halston", "Helmut Lang", "Hermès", "Hervé Léger", "Isabel Marant", "Isaia", "Issey Miyake",
  "IWC", "J. Mendel", "Jacquemus", "Jason Wu", "Jean Paul Gaultier", "Jil Sander",
  "Jimmy Choo", "John Galliano", "John Hardy", "John Lobb", "Judith Leiber", "Karl Lagerfeld",
  "Kate Spade", "Kenzo", "Kiton", "Kris Van Assche", "Lanvin", "Libertine", "Loewe",
  "Longchamp", "Louis Vuitton", "Maison Margiela", "Maiyet", "Manolo Blahnik",
  "Mansur Gavriel", "Marc Jacobs", "Mark Cross", "Marni", "Max Mara", "MCM", "Michael Kors",
  "Missoni", "Miu Miu", "Moncler", "Montblanc", "Moschino", "Mulberry", "Naeem Khan",
  "Nancy Gonzalez", "Narciso Rodriguez", "Off-White", "Omega", "Oscar de la Renta",
  "Paco Rabanne", "Panerai", "Patek Philippe", "Poiret", "Prabal Gurung", "Prada",
  "Proenza Schouler", "Raf Simons", "Ralph Lauren", "Rick Owens", "Roberto Cavalli",
  "Rodarte", "Rolex", "Sacai", "Saint Laurent", "Salvatore Ferragamo", "Schiaparelli",
  "Simone Rocha", "St. John", "Stella McCartney", "Stuart Weitzman", "Supreme", "TAG Heuer",
  "The Row", "Thierry Mugler", "Thom Browne", "Tiffany & Co.", "Tom Ford", "Tory Burch",
  "Ugg", "Valentino", "Van Cleef & Arpels", "Versace", "Vetements", "Victoria Beckham",
  "Viktor & Rolf", "Vionnet", "Vivienne Westwood", "Yeezy", "Yohji Yamamoto",
  "Yves Saint Laurent", "Yves Salomon", "Zac Posen", "Zenith", "Zuhair Murad",
];

export const CATEGORIES = [
  {
    name: "Handbags & Accessories",
    short: "Handbags",
    icon: "ShoppingBag",
    blurb: "Hermès, Chanel, and collectible leather goods — hardware, stitching, and date codes examined.",
  },
  {
    name: "Watches",
    short: "Watches",
    icon: "Watch",
    blurb: "From Rolex to Patek Philippe — movements, serials, and provenance verified.",
  },
  {
    name: "Jewelry",
    short: "Jewelry",
    icon: "Gem",
    blurb: "Fine and signed jewelry — gemstones, hallmarks, and maker's marks assessed.",
  },
  {
    name: "Furs",
    short: "Furs",
    icon: "Feather",
    blurb: "Heritage furs and outerwear — pelt quality, construction, and labeling reviewed.",
  },
  {
    name: "Shoes",
    short: "Shoes",
    icon: "Footprints",
    blurb: "Louboutin, Manolo, and beyond — materials, construction, and sizing marks authenticated.",
  },
  {
    name: "Ready-to-Wear",
    short: "Ready-to-Wear",
    icon: "Shirt",
    blurb: "Couture and designer garments — labels, textiles, and construction methods evaluated.",
  },
];

export const WHY_APPRAISAL = [
  {
    label: "Insurance",
    title: "Protect what you own",
    copy: "An appraisal documents the existence, condition, and replacement value of your belongings — the foundation of any luxury insurance policy.",
  },
  {
    label: "Estate",
    title: "Settle with certainty",
    copy: "A taxable estate requires efficient cataloging of property with an appraisal that meets IRS requirements.",
  },
  {
    label: "Divorce",
    title: "Divide with fairness",
    copy: "An appraisal establishes fair value, enabling the equal distribution of property both parties can trust.",
  },
  {
    label: "Donation",
    title: "Give with documentation",
    copy: "Recommended for charitable donations over $1,000 — and required by the IRS for anything above $5,000.",
  },
];

export const AUTH_SERVICES = [
  {
    label: "When Selling",
    title: "Trust sells",
    copy: "Verified, authentic items command higher prices on the secondary market. Documentation from a recognized authority turns hesitation into confidence.",
  },
  {
    label: "When Buying",
    title: "Protect yourself",
    copy: "Only with documentation that an item is counterfeit can you recoup losses on a fraudulent sale. Better yet — have the item authenticated before you purchase.",
  },
  {
    label: "Business Services",
    title: "For resale platforms",
    copy: "We help resale companies achieve the best possible selling prices through identification, authentication, and valuation. Fast turnaround, competitive rates.",
  },
];

export const BRAND_PROTECTION = [
  {
    label: "Investigations",
    title: "Discreet, evidence-grade inquiry",
    copy: "Confidential investigations into counterfeit sales, gray-market distribution, and IP infringement — documented to a standard suitable for legal action.",
  },
  {
    label: "Secret Shopping",
    title: "Anonymous test purchases",
    copy: "Covert acquisitions from suspect sellers and platforms to secure product evidence, verify sales practices, and establish chain of custody.",
  },
  {
    label: "Dissection",
    title: "Physical deconstruction",
    copy: "Systematic teardown of suspect goods — construction, materials, and hardware compared point-by-point against authentic references.",
  },
  {
    label: "Scientific Testing",
    title: "Laboratory analysis",
    copy: "Objective materials testing of leathers, metals, and textiles — producing court-ready findings that stand up to scrutiny.",
  },
];

export const CREDIBILITY = [
  { value: "18+", label: "Years of Expertise" },
  { value: "AAA", label: "Certified Appraiser" },
  { value: "USPAP", label: "Compliant Practice" },
  { value: "$500B", label: "Resale Market by 2030" },
  { value: "200+", label: "Brands Covered" },
];

export const SERVICE_TYPES = ["Appraisal", "Authentication", "Business Services"];

export const PURPOSES = ["Insurance", "Estate", "Divorce", "Donation", "Resale", "Other"];

export const TIMELINES = ["Standard (5–7 business days)", "Expedited (2–3 business days)", "Rush (24–48 hours)", "Flexible"];

export const CONTACT_REASONS = ["General Inquiry", "Appraisal Question", "Authentication Question", "Business Services", "Expert Witness / Legal", "Press / Media", "Other"];

export const HERO_IMAGE = "/hero-cartier.jpg";

export const ABOUT_IMAGE = "/graham-wetzbarger.jpg";

export const FASHION_DETECTIVE_URL = "https://www.thefashiondetective.com/";
export const LINKEDIN_URL = "https://www.linkedin.com/in/grahamwetzbarger/";
